import "@/App.css";
import ReadingPage from "@/ReadingPage";

export default function App() {
  return <ReadingPage />;
}
